export { default } from "./ProductDetailsLayout.jsx";
